import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminBackgroundTaskStatus } from '../../enums/admin-background-task-status';
import { BackgroundTaskStatusPipe } from '../../pipes';

@Component({
  selector: 'app-admin-background-task-status',
  imports: [CommonModule, BackgroundTaskStatusPipe],
  templateUrl: './admin-background-task-status.component.html',
  styleUrl: './admin-background-task-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBackgroundTaskStatusComponent {
  public readonly status = input.required<AdminBackgroundTaskStatus>();

  protected readonly cssClass = computed(() => {
    switch (this.status()) {
      case AdminBackgroundTaskStatus.InProgress:
        return 'text-sky-700';

      case AdminBackgroundTaskStatus.Done:
        return 'text-lime-600';

      default:
        return '';
    }
  });
}
